import React from "react"
import { useIntl } from "@components/Intl"
import { Button } from "@components/Buttons"
import { Box } from "@components/Layout"

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  loading: boolean
  onClick: () => void
}

const LoadMore: React.FC<Props> = ({ loading, onClick, ...rest }) => {
  const { messages } = useIntl()
  return (
    <Box py={5} display="flex" alignItems="center" justifyContent="center">
      <Button
        variant="purple-border"
        state={loading ? "loading" : ""}
        maxWidth={250}
        onClick={onClick}
        {...rest}
      >
        {messages.global.showMore}
      </Button>
    </Box>
  )
}

export default LoadMore
